$(document).on("click", ".btn-send-form, .send-form", function (e) {
    e.preventDefault();

    const btn = $(this);
    btn.addClass('disabled');

    const form = btn.closest('form');
    const action = btn.data('action');

    const data = new FormData(form[0]);

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: action,
        type: "post",
        data: data,
        processData: false,
        contentType: false,
        success: function (json) {

            $('.error').removeClass('error');
            $('.text-danger').remove();

            if (json.error) {
                $.each(json.error, function (i) {
                    let element = $('[name="' + i + '"]');
                    let parent = form.find(element).parent();

                    parent.addClass('error')
                        .after('<span class="text-danger">' + json['error_' + i] + '</span>');
                });

                btn.removeClass('disabled');
            }

            if (json.success) {
                form.hide();

                $("<div/>", { class: 'success' })
                    .appendTo(form.parent())
                    .html(`<h4>${json.success_title}</h4><p>${json.success_content}</p>`);
            }
        }
    });
});